import {useStopImpersonating} from '@common/admin/users/requests/use-impersonate-user';
import {useAuth} from '@common/auth/use-auth';
import {useBootstrapDataStore} from '@ui/bootstrap-data/bootstrap-data-store';
import {Button} from '@ui/buttons/button';
import {Trans} from '@ui/i18n/trans';

// Shown on every page while an admin is impersonating another user (bootstrap
// flag `is_impersonating`). "Return to your account" ends the impersonation and
// logs the original admin back in. Mounted once at the app root.
export function ImpersonationBanner() {
  const isImpersonating = useBootstrapDataStore(s => s.data.is_impersonating);
  const {user} = useAuth();
  const stop = useStopImpersonating();

  if (!isImpersonating) return null;

  return (
    <div className="fixed bottom-16 left-1/2 z-50 flex -translate-x-1/2 items-center gap-16 whitespace-nowrap rounded-full bg-warning py-6 pl-20 pr-8 text-sm text-black shadow-lg">
      <span>
        <Trans
          message="You are logged in as :name"
          values={{name: <b>{user?.name}</b>}}
        />
      </span>
      <Button
        size="xs"
        variant="flat"
        disabled={stop.isPending}
        onClick={() => stop.mutate()}
      >
        <Trans message="Return to your account" />
      </Button>
    </div>
  );
}
